export default __webpack_public_path__ + "static/media/progressionTricks.10dfff1e.png";